
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4690_3268)"}},[_c('path',{attrs:{"d":"M11 7h1.64v3.928H11V7zM8 7h1.64v3.928H8V7zM5 7h1.64v3.928H5V7zM2 7h1.64v3.928H2V7zM13.054 6.41V6H1v.41c0 .227.184.41.41.41h11.234a.41.41 0 00.41-.41zM13.59 12H.41a.41.41 0 00-.41.41v1.094c0 .226.184.41.41.41h13.18a.41.41 0 00.41-.41V12.41a.41.41 0 00-.41-.41zM.41 4.877h13.18a.41.41 0 00.215-.76L7.215.061a.41.41 0 00-.43 0L.195 4.117a.41.41 0 00.215.76zm6.311-2.465h.558a.41.41 0 110 .82H6.72a.41.41 0 110-.82z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4690_3268"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    